'use client'
import { SbBlokData, storyblokEditable } from '@storyblok/react/rsc'
import { FC } from 'react'

import { PhnxVideoHolder } from './VideoHolder'

interface VideoHolderBlokProps {
  blok: {
    id: string
    type: string
    setWidth: number
    layout: string
  } & SbBlokData
}

const VideoHolder: FC<VideoHolderBlokProps> = ({ blok }) => {
  let videos = []

  if (blok.id) {
    videos.push({
      url: blok.id,
      type: blok.type as 'youtube' | 'vimeo',
    })
  }

  return (
    <div
      {...storyblokEditable(blok)}
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      <PhnxVideoHolder video={videos} setWidth={blok.setWidth} layout={blok.layout} />
    </div>
  )
}

export default VideoHolder
